import { map } from 'rxjs/operators';

export const toPayload = <T>({ payload }: { payload: T }): T => payload;

export const mapPayload = <T>() => map<{ payload: T }, T>(toPayload);
